import * as React from "react";
import type { SVGProps } from "react";
const SvgIconTrending = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#clip0_40_8891)">
      <path
        d="M7.1 1.16Q7 1.1 6.89 1.1q-.12 0-.21.06-.1.06-.1.17-.02.1.03.2c1.3 2.25 1.58 5.31-.2 7-.68-.57-1.23-1.3-1.59-2.1-.65.36-1.2.9-1.57 1.55s-.56 1.4-.54 2.14q.04 1.01.46 1.92.44.91 1.18 1.58.75.66 1.7 1 .95.32 1.95.27c3.4 0 5.17-2.12 5.29-4.77.14-3.17-2.12-7.07-6.2-8.96"
        fill="#FEF4F2"
      />
      <path
        d="M7.1 1.16Q7 1.1 6.89 1.1q-.12 0-.21.06-.1.06-.1.17-.02.1.03.2c1.3 2.25 1.58 5.31-.2 7-.68-.57-1.23-1.3-1.59-2.1-.65.36-1.2.9-1.57 1.55s-.56 1.4-.54 2.14q.04 1.01.46 1.92.44.91 1.18 1.58.75.66 1.7 1 .95.32 1.95.27c3.4 0 5.17-2.12 5.29-4.77.14-3.17-2.12-7.07-6.2-8.96"
        stroke="#EF6144"
        strokeWidth={1.15}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_40_8891">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIconTrending;
